import React from 'react'
import ReactDOM from 'react-dom'
import { isUserV2Path } from './UserAppV2/path'

const rootElement = document.getElementById('root')

if (isUserV2Path(window.location.pathname)) {
  import('./UserAppV2').then(({ default: UserAppV2 }) => {
    ReactDOM.render(
      <React.StrictMode>
        <UserAppV2 />
      </React.StrictMode>,
      rootElement
    )
  })
} else {
  Promise.all([
    import('./index.scss'),
    import('./App'),
    import('axios'),
    import('react-redux'),
    import('redux-persist/integration/react'),
    import('./redux/configureStore')
  ]).then(([
    ,
    { default: App },
    { default: axios },
    { Provider },
    { PersistGate },
    { store, persistor }
  ]) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL

    ReactDOM.render(
      <React.StrictMode>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <App />
            </PersistGate>
          </Provider>
      </React.StrictMode>,
      rootElement
    )
  })
}
